const scheduledServicesByUserAndDayModal = {
  titleScheduled: "Serviços Agendados",
  titleCompleted: "Serviços Realizados",
  serialNumber: "Número de Série",
  place: "Local",
  scheduledDate: "Data do Agendamento",
  accountable: "Responsável",
  confirm: 'Você realmente deseja excluir este serviço agendado?',
  title: 'EXCLUIR SERVIÇO AGENDADO',
};

export default scheduledServicesByUserAndDayModal;
